import React, { Component } from 'react';
import './editalumni.css';
import { Input, Modal, Button, Tabs, Row, Col, Dropdown, Icon, Menu, Collapse, Form, Select, Radio, DatePicker, Checkbox } from 'antd';
import moment from 'moment';
const TabPane = Tabs.TabPane;
const FormItem = Form.Item;
const Panel = Collapse.Panel;


const customPanelStyle = {
    background: '#fff',
    borderRadius: 4,
    marginBottom: 24,
    border: 0,
    overflow: 'hidden',
};

class RecordManagement extends Component {
    render() {
        return (
            <div>
                <Collapse defaultActiveKey={'1'} accordion style={{ border: 'none', backgroundColor: 'inherit' }}>
                    <Panel header="Record Management" key="1" style={customPanelStyle}>
                        <p>
                            {/* Record Management */}
                            <Form layout="vertical">
                                <Row type="flex" justify="space-between">
                                    <Col xs={22} sm={22} md={7} lg={7} xl={7}>
                                        <FormItem
                                            label="Date Created:"
                                        >
                                            <Input disabled={true} placeholder="MM / DD / YYYY" />
                                        </FormItem>
                                    </Col>
                                    <Col xs={22} sm={22} md={7} lg={7} xl={7}>
                                        <FormItem
                                            label="Username:"
                                        >
                                            <Input disabled={true} placeholder="Username" />
                                        </FormItem>
                                    </Col>
                                    <Col xs={22} sm={22} md={7} lg={7} xl={7}>
                                        <FormItem
                                            label="Page Authorization:"
                                        >
                                            <Input disabled={true} placeholder="Viewable" />
                                        </FormItem>
                                    </Col>
                                    <Col xs={22} sm={22} md={7} lg={7} xl={7}>
                                        <FormItem
                                            label="Special Flag 1:"
                                        >
                                            <Input placeholder="Special Flag" />
                                        </FormItem>
                                    </Col>
                                    <Col xs={22} sm={22} md={7} lg={7} xl={7}>
                                        <FormItem
                                            label="Special Flag 2:"
                                        >
                                            <Input placeholder="Special Flag" />
                                        </FormItem>
                                    </Col>
                                    <Col xs={22} sm={22} md={7} lg={7} xl={7}>
                                        <FormItem
                                            label="Special Flag 3:"
                                        >
                                            <Input placeholder="Special Flag" />
                                        </FormItem>
                                    </Col>
                                    <Col xs={22} sm={22} md={7} lg={7} xl={7}>
                                        <FormItem
                                            label="Special Flag 4:"
                                        >
                                            <Input placeholder="Special Flag" />
                                        </FormItem>
                                    </Col>
                                    <Col xs={22} sm={22} md={7} lg={7} xl={7}>
                                        <FormItem
                                            label="Special Flag 5:"
                                        >
                                            <Input placeholder="Special Flag" />
                                        </FormItem>
                                    </Col>
                                </Row>
                            </Form>
                        </p>
                    </Panel>
                </Collapse>
                <Row type="flex" justify="center">
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Form layout="vertical" style={{ padding: "50px 5px 50px 5px" }}>
                            <Row type="flex" justify="space-between">
                                <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                                    <Button className="cancel-btn" style={{ width: '100%', fontWeight: 600, boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.3)', marginBottom:'10px' }}>Cancel</Button>
                                </Col>
                                <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                                    <Button style={{ width: '100%', fontWeight: 600, boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.3)', marginBottom:'10px' }} type="primary">Save Changes</Button>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default RecordManagement;


// WEBPACK FOOTER //
// ./src/components/MaintainAlumni/RecordManagement.js